{
  "backButton": "الرجوع إلى {prevMenuButton}",
  "moreActions": "المزيد من الإجراءات",
  "unavailable": "غير مُتوفر، قُم بالتوسيع للحصول على التفاصيل"
}
